import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

const useDuplicateFlowMutation = () => {
  return ApprovalFlows.duplicateFlow();
};

export default useDuplicateFlowMutation;
